import AuthLayout from "layouts/AuthLayout";
import AuthHeading from "components/v2/Auth/AuthHeading";
import ResetPasswordForm from "./ResetPasswordForm";

const PasswordResetOptions = () => (
	<AuthLayout>
		<AuthHeading heading="Forgot your password?" subheading="We'll email you a code to get you back into your library." />
		<ResetPasswordForm />
	</AuthLayout>
);

export default PasswordResetOptions;
